<div class="o-grid">
	<div class="o-grid__cell o-grid__cell--w-100">
		<div class="c-card">
			<div class="c-content c-content--xxl">
				<div class="o-grid o-grid--wrap o-grid--center-h">
					<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
						<p class="c-text c-text--center c-text--s12 u-ost-xxl u-osb-xl">{{ 'Booking.Booking_Failed' | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
						<a href="" class="c-button c-button--s2 c-button--lg u-osb-xxl">{{ 'Booking.Back_To_Main' | translate }}</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
